var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduction2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 33,
    viewBox: "0 0 43 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6746 20.939H33.8641L39.5619 26.654V20.939H41.7266C42.1242 20.939 42.4444 20.6078 42.4444 20.1964V1.55754C42.4444 1.1462 42.1242 0.815063 41.7266 0.815063H14.4489C14.0512 0.815063 13.7311 1.1462 13.7311 1.55754V5.09068",
    stroke: "#F5FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57769 5.1467H28.8553C29.253 5.1467 29.5732 5.47789 29.5732 5.88928V25.9391C29.5732 26.3506 29.253 26.6818 28.8553 26.6818H13.736L8.0382 32.3967V26.6818H1.57769C1.18 26.6818 0.859863 26.3506 0.859863 25.9391V5.88928C0.859863 5.47789 1.18 5.1467 1.57769 5.1467Z",
    fill: "#FEA219",
    stroke: "#F5FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9022 15.9142V9.45374H13.7735V15.9142M8.74343 9.45374H5.18684V12.3251C5.18684 12.3251 7.3073 12.3251 8.04562 12.3251V15.1964H4.48907L8.74343 9.45374Z",
    stroke: "#F5FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.62 12.3252H13.0631",
    stroke: "#F5FBFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4171 12.3251H24.5706M4.44879 18.0678H25.9838M4.44879 20.9391H24.5481M4.44879 23.8104H21.6768M37.4153 9.45376H29.4523M37.4153 12.3251H29.5157M37.4153 15.1964H29.4841M37.4153 18.0678H29.8647M37.4194 6.58243C37.4194 6.58243 30.0202 6.58243 29.5906 6.58243M16.6445 8.73591V15.1964C16.6445 15.1964 19.631 15.1964 20.2337 15.1964L16.6445 8.73591ZM25.9838 9.45376H22.3946V15.1964H25.9838V9.45376Z",
    stroke: "#F5FBFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduction2);
export default __webpack_public_path__ + "static/media/introduction-2.3b0c7aeb.svg";
export { ForwardRef as ReactComponent };